// Google Analytics 4 utility for FileNesto
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let initialized = false;
// Pageviews that arrive before GA is ready are queued and drained after init
const pageviewQueue = [];

function _doInit() {
  if (!GA_ID || initialized || typeof window === "undefined") return;
  initialized = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false });

  // Send any pageviews that fired before init
  pageviewQueue.splice(0).forEach((path) => {
    window.gtag("config", GA_ID, { page_path: path });
  });
}

function _scheduleInit() {
  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(_doInit);
  } else {
    setTimeout(_doInit, 0);
  }
}

export function initGA() {
  if (!GA_ID || typeof window === "undefined") return;
  if (document.readyState === "complete") {
    _scheduleInit();
  } else {
    window.addEventListener("load", _scheduleInit, { once: true });
  }
}

export function trackPageView(path) {
  if (!GA_ID) return;
  if (window.gtag) {
    window.gtag("config", GA_ID, { page_path: path });
  } else {
    // Queue until GA is initialized
    pageviewQueue.push(path);
  }
}

export function trackEvent(name, params = {}) {
  if (typeof window === "undefined") return;
  if (window.gtag) {
    window.gtag("event", name, params);
  }
}
